<template>
  <c-dropdown class="ml-1 d-inline" color="light">
    <template #toggler-content>
      <c-icon name="cil-tags" />
    </template>
    <c-dropdown-item href="#">
      Add label
      <c-badge class="ml-1" color="danger">Home</c-badge>
    </c-dropdown-item>
    <c-dropdown-item href="#">
      Add label
      <c-badge class="ml-1" color="info">Job</c-badge>
    </c-dropdown-item>
    <c-dropdown-item href="#">
      Add label
      <c-badge class="ml-1" color="success">Clients</c-badge>
    </c-dropdown-item>
    <c-dropdown-item href="#">
      Add label
      <c-badge class="ml-1" color="warning">News</c-badge>
    </c-dropdown-item>
  </c-dropdown>
</template>

<script>
export default {
  name: 'LabelDropdown',
};
</script>
